import React from 'react';
import {
  Search, User, Sparkles, ArrowRight, DraftingCompass, Brain, BadgeCheck, Ban,
  Waypoints, RefreshCw, Repeat, TrendingUp, Flower2, CheckCircle2, Microscope,
  Clock, ChevronRight, Focus, ClipboardCheck, LayoutGrid, ShieldCheck, Lock,
  Heart, FlaskConical, PlayCircle, Play, Pause, HeartPulse, Quote, Eye, GitFork,
  Sun, AlarmClock, Sunrise, Hourglass, Footprints, PanelTop, Moon, ShieldPlus,
  ListChecks, Download, PlusCircle, Check, ArrowUpRight, MoveRight, Zap, Shield,
  ArrowDown, SlidersHorizontal, Bookmark, Circle,
  Save, Sigma, Calculator, Plus, History, BellRing, Pill, Ruler, Flag, X,
  Leaf, PartyPopper, BookOpen, Compass, Minus, Dumbbell, Scale, BedDouble,
  ListTodo, Accessibility, UtensilsCrossed, ArrowLeft, RotateCw, Shapes,
  CircleDot, Tag, Square, SquareCheckBig
} from 'lucide-react';

// Maps the finalized Stitch design's Material Symbol names to lucide-react icons
const MAP = {
  search: Search,
  person: User,
  auto_awesome: Sparkles,
  arrow_forward: ArrowRight,
  architecture: DraftingCompass,
  neurology: Brain,
  verified: BadgeCheck,
  block: Ban,
  hub: Waypoints,
  sync: RefreshCw,
  repeat: Repeat,
  trending_up: TrendingUp,
  self_improvement: Flower2,
  check_circle: CheckCircle2,
  biotech: Microscope,
  schedule: Clock,
  chevron_right: ChevronRight,
  filter_center_focus: Focus,
  psychology: Brain,
  assignment_turned_in: ClipboardCheck,
  grid_view: LayoutGrid,
  verified_user: ShieldCheck,
  lock: Lock,
  favorite: Heart,
  science: FlaskConical,
  play_circle: PlayCircle,
  play_arrow: Play,
  pause: Pause,
  healing: HeartPulse,
  format_quote: Quote,
  visibility: Eye,
  alt_route: GitFork,
  flare: Sun,
  alarm: AlarmClock,
  wb_twilight: Sunrise,
  hourglass_top: Hourglass,
  directions_walk: Footprints,
  window: PanelTop,
  nightlight: Moon,
  health_and_safety: ShieldPlus,
  add_task: ListChecks,
  download: Download,
  add_circle: PlusCircle,
  done: Check,
  north_east: ArrowUpRight,
  arrow_right_alt: MoveRight,
  wb_sunny: Sun,
  bolt: Zap,
  shield: Shield,
  south: ArrowDown,
  tune: SlidersHorizontal,
  check: Check,
  bookmark_border: Bookmark,
  bookmark: Bookmark,
  save: Save,
  functions: Sigma,
  calculate: Calculator,
  add: Plus,
  history: History,
  notifications_active: BellRing,
  medication: Pill,
  straighten: Ruler,
  flag: Flag,
  close: X,
  eco: Leaf,
  celebration: PartyPopper,
  menu_book: BookOpen,
  explore: Compass,
  remove: Minus,
  fitness_center: Dumbbell,
  monitor_weight: Scale,
  bedtime: BedDouble,
  checklist: ListTodo,
  elderly: Accessibility,
  restaurant: UtensilsCrossed,
  star: Sparkles,
  arrow_back: ArrowLeft,
  autorenew: RotateCw,
  category: Shapes,
  radio_button_checked: CircleDot,
  check_box: SquareCheckBig,
  check_box_outline_blank: Square,
  tag: Tag,
};

/**
 * Icon renders a lucide-react icon that scales with the surrounding font-size.
 * Pass sizing via className (e.g. text-[20px]) and color via className (e.g. text-surface-tint).
 */
export default function Icon({ name, className = '', strokeWidth = 2, ...rest }) {
  const Cmp = MAP[name] || Circle;
  return (
    <Cmp
      className={className}
      style={{ width: '1em', height: '1em', flexShrink: 0 }}
      strokeWidth={strokeWidth}
      aria-hidden="true"
      {...rest}
    />
  );
}
